<ng-container *ngIf="displayListCarrierName; else deliveryList">
    <div *ngFor="let carrier of carrierWithDeliveries">
        <span class="itemCarrier"
              (click)="showDeliveries[carrier.blueyonderCarrierCode] = !showDeliveries[carrier.blueyonderCarrierCode]"
              [class._active]="showDeliveries[carrier.blueyonderCarrierCode]">
            <i class="fa fa-chevron-circle-down collapseIcon" *ngIf="!showDeliveries[carrier.blueyonderCarrierCode]"></i>
            <i class="fa fa-chevron-circle-up collapseIcon" *ngIf="showDeliveries[carrier.blueyonderCarrierCode]"></i>
            <span class="itemCarrier-name">{{ carrier.carrierName }}</span>
            <i class="fa fa-warning text-warning" [i18n]="[{target: 'attribute:title', key: 'bluechat.note-creation.carriers.not-assigned'}]" *ngIf="!carrier.noteCreationAllowed"></i>
            <two-press-button buttonClass="fas fa-trash" (clicked)="deleteCarrier.emit(carrier.bluechatCarrierCode)"></two-press-button>
        </span>
        <ul class="deliveriesList" *ngIf="showDeliveries[carrier.blueyonderCarrierCode]">
            <li class="deliveriesList-item" *ngFor="let deliveryNumbers of carrier.deliveryNumbers">
                {{ deliveryNumbers }}
            </li>
        </ul>
    </div>
</ng-container>

<ng-template #deliveryList>
    <ul class="deliveriesList">
        <li class="deliveriesList-item no-header" *ngFor="let delivery of deliveries">
            {{ delivery.deliveryNumber }}
        </li>
    </ul>
</ng-template>
